export default "__VITE_ASSET__B70nvrlN__"